<template>
  <v-textarea
    class="text-capitalize"
    dense
    outlined
    auto-grow
    v-bind="$attrs"
    v-on="$listeners"
    :label="$t(label)"
    :value="value"
    :rules="rules"
  />
</template>

<script>
import { createValidationRules } from '@/utils'

export default {
  name: 'BaseTextArea',

  props: {
    label: String,
    value: String,
    required: Boolean,
    characterLimit: {
      type: Number,
      required: true
    }
  },

  computed: {
    rules() {
      return createValidationRules({
        label: this.label,
        required: this.required,
        characterLimit: this.characterLimit
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>
